export const blockIconsNotificationSync = (
	<span className='material-symbols-outlined'>sync</span>
);
